import React from 'react';
import { Link } from 'react-router-dom';
import '../../components/account/AccountLayout.css';

export type AdminSection = 'competitions' | 'evaluations' | 'users' | 'agent';
export const ADMIN_SECTIONS: { key: AdminSection; label: string }[] = [
  { key: 'competitions', label: 'Competitions' },
  { key: 'evaluations', label: 'Evaluations' },
  { key: 'users', label: 'Users' },
  { key: 'agent', label: 'Agent' },
];

export function toAdminSection(value: string | null): AdminSection {
  return ADMIN_SECTIONS.some((s) => s.key === value) ? (value as AdminSection) : 'competitions';
}

const AdminNav: React.FC<{ active: AdminSection }> = ({ active }) => (
  <nav className="account-nav" aria-label="Admin" data-tour="admin-nav">
    {ADMIN_SECTIONS.map((s) => (
      <Link key={s.key} to={`/admin?section=${s.key}`} replace aria-current={s.key === active ? 'page' : undefined}
        className={`account-nav__link${s.key === active ? ' account-nav__link--active' : ''}`}>{s.label}</Link>
    ))}
  </nav>
);

export default AdminNav;
